module.exports = __webpack_public_path__ + "img/FR00006.ad821252.png";